import { render, staticRenderFns } from "./WorkGeneralInformation.vue?vue&type=template&id=6c17a69e&scoped=true&"
import script from "./WorkGeneralInformation.vue?vue&type=script&lang=js&"
export * from "./WorkGeneralInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c17a69e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c17a69e')) {
      api.createRecord('6c17a69e', component.options)
    } else {
      api.reload('6c17a69e', component.options)
    }
    module.hot.accept("./WorkGeneralInformation.vue?vue&type=template&id=6c17a69e&scoped=true&", function () {
      api.rerender('6c17a69e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MemoDeal/WorkGeneralInformation.vue"
export default component.exports